import { Globe } from "lucide-react";
import { LANGUAGES, getCurrentLanguage } from "./LanguageSelector";

const LanguageSwitcher = ({ compact = false }: { compact?: boolean }) => {
  const current = getCurrentLanguage();
  const lang = LANGUAGES.find((l) => l.code === current) || LANGUAGES[0];

  const open = () => window.dispatchEvent(new Event("open-language-selector"));

  return (
    <button
      onClick={open}
      className={`notranslate inline-flex items-center gap-1.5 rounded-full border border-border/50 hover:border-primary/50 hover:bg-card/60 transition-colors text-muted-foreground hover:text-foreground ${
        compact ? "px-2.5 py-1.5 text-[11px]" : "px-3 py-2 text-xs"
      }`}
      aria-label="Change language"
    >
      <Globe size={compact ? 12 : 13} />
      <span className="font-semibold tracking-wide">{lang.flag} {lang.code.toUpperCase().split("-")[0]}</span>
    </button>
  );
};

export default LanguageSwitcher;
